import { create } from 'zustand';

interface ManageCustomersResponsiveOverlayErrorStore {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export const useManageCustomersResponsiveOverlayError = create<ManageCustomersResponsiveOverlayErrorStore>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false })
}));
